import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { translateError } from '../utils';

export default function Login() {
  const { login } = useAuth();
  const [cedula, setCedula] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!cedula || !password) {
      setError('Ingresa cédula y contraseña');
      return;
    }
    setLoading(true);
    try {
      await login(cedula, password);
    } catch (err) {
      setError(translateError(err));
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo">
          <div className="login-icon">🏢</div>
          <h1>Control de Visitas</h1>
          <p>Gestión inteligente de visitantes residenciales</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-error">⚠️ {error}</div>}
          <div className="form-group">
            <label>Número de cédula</label>
            <input
              type="text"
              value={cedula}
              onChange={(e) => setCedula(e.target.value)}
              placeholder="Ingresa tu cédula"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
            {loading ? 'Verificando identidad...' : 'Iniciar Sesión'}
          </button>
        </form>
        <p className="text-sm text-center mt-16">
          Contacta al administrador para obtener tu cuenta
        </p>
      </div>
    </div>
  );
}